export default __webpack_public_path__ + "static/media/shopping-cart.dd593011.png";